/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Components */
import Card2x3 from '../Card2x3';

/* Utils */
import { noOp } from '../../utils/functions';
import useLockIcon from '../../hooks/useLockIcon';
import parentalControlBlock from '../../utils/parentalControlUtils';
import { useSubtitleVod } from './utils';
import { useTitle } from '../../utils/metaDataUtils';
import { Content, Show } from '../../storage/models';

export function CardVod({
  index,
  item: content = {},
  onArrowPress = noOp,
  onEnterPress = noOp,
  onFocusRestored = undefined,
}) {
  const { images } = content || {};

  const isNonEntitledContent = useLockIcon(content);
  const isContentBlockedByParentalControl = parentalControlBlock(content);

  const title = useTitle(content);
  const subtitle = useSubtitleVod(content);

  return (
    <Card2x3
      index={index}
      content={content}
      images={images}
      title={title}
      subtitle={subtitle}
      isNonEntitledContent={isNonEntitledContent}
      isContentBlockedByParentalControl={isContentBlockedByParentalControl}
      onArrowPress={onArrowPress}
      onEnterPress={onEnterPress}
      onFocusRestored={onFocusRestored}
    />
  );
}

CardVod.propTypes = {
  index: PropTypes.number.isRequired,
  item: PropTypes.oneOfType([
    PropTypes.instanceOf(Content),
    PropTypes.instanceOf(Show),
  ]),
  onArrowPress: PropTypes.func,
  onEnterPress: PropTypes.func,
  onFocusRestored: PropTypes.func,
};

export default memo(CardVod);
